import { Component } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'tart-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
})
export class HelpComponent {
  guideURL = `${environment.api}/File/Download?path=058d03e3-9abd-409f-8ad2-4cfba8d189a2/` +
    'ApplicationFiles/d92284eb-f57f-46a0-9d07-82b489692a0a.pdf';
}
